const VueAutoRegister = {
  install (Vue) {
    const requireComponent = require.context('./components/Icon', true, /\.vue$/);
    requireComponent.keys().forEach(fileName => {
      const componentConfig = requireComponent(fileName);
      const componentName = componentConfig.default.name || fileName.replace(/^\.\/(.*)\.\w+$/, '$1');
      Vue.component(componentName, componentConfig.default || componentConfig);
    });
  }
};

export default VueAutoRegister;